import {validationMixin} from 'vuelidate';
import {required, email, maxLength} from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import {
    RESTORE_PASSWORD
} from "@/store/action-types";
export default {
    name: 'restore-password',
    breadcrumb() {
        return {
            label: this.$t('restorePassword'),
            parentsList: [
                {
                    path: '/',
                    label: this.$t('main'),
                    name: 'home'
                }
            ]
        }
    },
    mixins: [validationMixin],
    data(){
        return {
            validationErrors: {},
            showSuccess: false,
            payload: {
                email: '',
            },
            params: {
                title: '',
                description: '',
                keywords: '',
                image: ''
            },
        }
    },
    head: {
        meta: function () {
            let meta = [
                { n: 'description', c: this.params.description, id: 'description' },
                { n: 'keywords', c: this.params.keywords, id: 'keywords' },
                { n: 'og:title', c: this.params.title, id: 'og:title' },
                { n: 'og:description', c: this.params.description, id: 'og:description' },
            ]

            if (Object.keys(this.$route.query).length > 0) {
                meta.push({ n: 'robots', c: 'noindex, nofollow' })
                return meta
            } else {
                return meta
            }
        },
        link: function () {
            let route = this.$route.path
            return [
                { rel: 'canonical', href: window.location.origin + this.$route.path, id: 'canonical' },
            ]
        }
    },
    validations: {
        payload: {
            email: {
                required,
                maxLength: maxLength(30),
                email
            },
        }
    },
    computed:{
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.required) {
                error.push(this.$t('validationRequired'))
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(this.$t('validationMax').replace(':count', 30));
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t('validationEmail'))
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    methods: {
        ...mapActions({
            restore: `auth/${RESTORE_PASSWORD}`
        }),
        resetForm(){
            this.$v.$reset();
            this.payload.email = '';
        },
        submit(){
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.restore(this.payload)
                    .then(() => {
                        this.showSuccess = true;
                        this.resetForm();
                    }).catch(error => {
                    if(error.response.status === 422){
                        this.$toasted.error(error.response.data.message).goAway(5000);
                        this.validationErrors = error.response.data.errors
                    }
                });
            }
        }
    }
}
